
class BaseModel

  subModels: {}

  # -------------------------------------------

  constructor: (obj) ->
    @inject(obj) if obj?

  # -------------------------------------------

  inject: (obj) ->

    for key, value of obj
      if @subModels[key]?
        Klass = @subModels[key]
        model = new Klass(value)
        @set key, model
      else
        @set key,value
    return

  # -------------------------------------------

  get: (key) ->
    return null unless @[key]?
    @[key]

  # -------------------------------------------

  set: (key, value) ->
    key = key.charAt(0).toLowerCase() + key.slice(1)
    @[key] = value


module.exports = BaseModel


// WEBPACK FOOTER //
// ./coffee/base/base-model.coffee